import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as BookingAction from "../../../actions/bookingAction";

const useStyles = makeStyles((theme) => ({
  input: {
    marginBottom: "16px",
    backgroundColor: "#fff",
    padding: 6,
    borderRadius: 3,
  },
}));

 const SearchBar = ({ status, inputValue, selectedPartner }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const startDate = useSelector((state) => state.bookingListing.filterStartDate);
  const endDate = useSelector((state) => state.bookingListing.filterEndDate);
  const secId = useSelector((state) => state.bookingListing.getSecId);
  const [filterSecId, setFilterSecId] = useState(secId);
  const [ value, setValue ] = useState("");

  useEffect(() => {
    // dispatch(BookingAction.searchBooking("", status, secId, 1));
    setFilterSecId(secId);
  }, [startDate, endDate, secId]);
  
  useEffect(() => {
    dispatch(BookingAction.getStatus( status));
  }, []);
  const handleChange = (event) => {
    console.log(event.target.value)
    let search = event.target.value
    setValue(search)
    console.log(event.target.value, status, selectedPartner);
    // dispatch(BookingAction.searchBooking(value.target.value, status, filterSecId, 1));
    dispatch(BookingAction.searchPartnerBooking(search, status, selectedPartner, 1));
    dispatch(BookingAction.searchPartnerTextvalue(search));
    dispatch(BookingAction.searchTruevlue(true, status))
  };

  return (
    <TextField
      className={classes.input}
      size="small"
      placeholder={"Search"}
      value={inputValue}
      fullWidth={true}
      onChange={handleChange}
      InputProps={{ disableUnderline: true }}
    />
  );
};

export default SearchBar;
